export const monthNames = [
    "Ene", "Feb", "Mar", "Abr", "May", "Jun", 
    "Jul", "Ago", "Sep", "Oct", "Nov", "Dic"
];

export const PROYECTOS_COLLECTION = 'proyectos_v2';

export const StatusBadge = ({ status }) => {
    const statusStyles = {
        'Atrasado': 'bg-red-100 text-red-800',
        'Por Vencer': 'bg-orange-100 text-orange-800',
        'A Tiempo': 'bg-green-100 text-green-800',
        'En Espera de Proveedor': 'bg-purple-100 text-purple-800',
        'Sin Fecha': 'bg-gray-100 text-gray-600',
        'Activo': 'bg-orange-100 text-orange-800',
        'En Revisión Final': 'bg-blue-100 text-blue-800',
        'Terminado Internamente': 'bg-indigo-100 text-indigo-800',
        'Pendiente de Factura': 'bg-yellow-100 text-yellow-800',
        'Facturado': 'bg-green-100 text-green-800',
        'Archivado': 'bg-gray-100 text-gray-700',
        'Cotización': 'bg-gray-200 text-gray-800',
    };
    return <span className={`px-2 inline-flex text-xs leading-5 font-semibold rounded-full ${statusStyles[status] || 'bg-gray-100'}`}>{status}</span>;
};